<mx-grid (customize)='onCustomize($event)'></mx-grid>